// import Navbar from './Navbar';
import Footer from './Footer';
import { useContext } from 'react';

const ErrorFallback = ({hasErrorBondary, error, errorInfo, firstStack, stack, isUserError}) => {

  let errorMsg, errorConnue = false
  if (error) {
    if (error.toString().includes("Cannot read properties of null (reading 'split')")
    && firstStack.includes('InputText')) {
      errorConnue = true
      errorMsg = `Nous avons très probablement un soucis avec les dates et heures prévisionnelles de cette tâche.`
    } else if (error.toString().includes("Cannot read properties of null (reading 'split')")
    && firstStack.includes('Taches')) {
      errorConnue = true
      errorMsg = `Nous avons très probablement un soucis avec les dates ou heures prévisionnelles sur l'une de vos tâches.
      L'une d'elles doit avoir au moins une date non renseignée et génère une erreur`
    } else {
      errorMsg = `${error.toString()}`
    }
  }
  
  let stackMessage=[];
  for (let i=1; i < 4; i++) {
    stackMessage.push(<p className="detail-error-msg" key={i}>{errorInfo.componentStack ? `${stack[i]}` : 'No stack trace available.'}</p>);
  }

  return (
    <>
      {/* {!isUserError && <Navbar hasErrorBondary={hasErrorBondary} isUserError={isUserError}/>} */}
      <div className={`oops-container ${isUserError && 'oops-container-shorter'}`} id="oops-500">
        <div className={`oops-wrapper`} id="oops-wrapper-500">
          <div className="oops-content" id="oops-content-500">
            <div className="oops-text">
              <div className="oops-title">
                <h1>Oups !</h1>
              </div>
              <p>Désolé, mais Kaiju le chat polisson a débranché le mauvais fil et quelque chose d'inattendu est survenu... <br />En cas de besoin, contactez la DSI</p>
              <p className="detail-error-msg">{error && errorMsg}</p>
              {/* {!isUserError && <p className="detail-error-msg">{error && `Message --> ${error.toString()}`}</p>} */}
              {!errorConnue && !isUserError && stackMessage}
            </div>
            <a href="/" className="oops-btn" id="btn-500">Retour à l'accueil</a>
          </div>
          <img src="/images/error-500.svg" alt="Error-500" className="img-error" id="img-500"/>
        </div>
      </div>
      {!isUserError && <Footer />}
    </>
  )
}

export default ErrorFallback
